module.exports = __webpack_public_path__ + "img/cj.83a4e9b6.jpg";